import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { listThemes } from 'app-support/themes/state/actions'
import { KnockFormDropdown } from '@cbgms/components/form/KnockFormDropdown'
import { GETThemesResponseRow } from '@cbgms/api/modules/themes'

interface IMapDispatchToProps {
  listThemes: typeof listThemes
}

const enhance = connect<void, IMapDispatchToProps>(undefined, { listThemes })

export const Themes: React.FC<IMapDispatchToProps> = props => {
  const { t } = useTranslation()

  return (
    <KnockFormDropdown<GETThemesResponseRow>
      label={t('shop.select_theme')}
      name='Shop.ThemeUUID'
      text={row => row.Theme.Name}
      value={row => row.Theme.UUID}
      action={props.listThemes as any}
      fields={['Theme.UUID', 'Theme.Name', 'Theme.IsDefault']}
    />
  )
}

Themes.displayName = 'Themes'

export default enhance(Themes)
